// src/hooks/useBanner.js
import {useQuery} from 'react-query';
import {fetchBanner} from "../api/bannerApi";

export const useBanner = (pageNumber, pageSize) => {
    return useQuery(['banner', pageNumber, pageSize], () => fetchBanner(pageNumber, pageSize), {
        refetchOnWindowFocus: false, // 根據需求調整
    });
};
